import { LoadingButton } from "@mui/lab"
import { Avatar, Box, Paper, TextField, Typography } from "@mui/material"
import Container from '@mui/material/Container';
import { FieldValues, useForm } from "react-hook-form"
import KeyIcon from '@mui/icons-material/Key';
import agent from "../../app/api/agent";
import { resetPassword } from "../../app/models/resetPassword";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom"


export default function ResetPassword() {
  const navigate = useNavigate()
  let [searchParams] = useSearchParams();
  
  const {register, handleSubmit, setError, formState: {isSubmitting, errors, isValid}} = useForm({
      mode: 'onTouched' // tell what mode we want it to use to valid inputs. onTouch: as soon as they click into an input and then click out again, it's going to validate the field
  })
  const email = searchParams.get('email')

  const tokenWithSpace = searchParams.get('token')
  let token = ''

  if (tokenWithSpace === null) return <Typography>Sorry, you cannot access this site without providing your email address. If you want to reset your password, please go to the <Link to="/forgetPassword">'forget password'</Link> page:</Typography>
          

  if (tokenWithSpace.indexOf(' ') >= 0) {
      token = tokenWithSpace.split(' ').join('+')
  } else {
      token = tokenWithSpace
  }
 
  function handleSumitData(data: FieldValues) {
     
      let resetInfo : resetPassword = {
          email: email,
          token: token,
          password: data.password
      }
      
      agent.Account.resetPassword(resetInfo)
        .then(() => {
          toast.success('Your password has been reset!')
          navigate('/login')})
        .catch((error) => setError('password', {message: error.data}))
      
  }

  return (
      <Container component={Paper} maxWidth="sm" sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', p: 4}}>
            
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
            <KeyIcon />
          </Avatar>
          <Typography component="h1" variant="h5" sx={{mb: 2}}>
              Reset password
          </Typography>
          <Typography variant='body1'>Please input a new password:</Typography>
          <Box component="form" 
            onSubmit={handleSubmit(handleSumitData)} 
                noValidate sx={{ mt: 1 }}>
            
            <TextField
              margin="normal"
              required
              fullWidth
              label="Password"
              type="password"
              {...register('password', {
                  required:  'Password is required',
                  pattern: {
                    value: /(?=^.{6,10}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?/&gt;.&lt;,])(?!.*\s).*$/,
                    message: 'password does not meet complexity requirements'
                  }
                })}
              error={!!errors.password} // !! casts username into a boolean. If it is false, it will give a red color
              helperText={errors?.password?.message as string}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              label="Confirm Password"
              type="password"
              {...register('confirmPassword', {
                  required:  'Please confirm your password',
                  validate: (value, formValues) => value === formValues.password || 'two passwords do not match'
                })}
              error={!!errors.confirmPassword} // !! casts username into a boolean. If it is false, it will give a red color
              helperText={errors?.confirmPassword?.message as string}
            />

            <LoadingButton
              loading={isSubmitting}
              disabled={!isValid}
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Submit
            </LoadingButton>
            
          </Box>
      </Container>
  )

}